import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const ClearEventsModal = ({ isOpen, leagueName, isClearing, onConfirm, onCancel }) => {
  return (
    <Modal isOpen={isOpen} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>
        Clear League Events
      </ModalHeader>
      <ModalBody>
        <p>Are you sure you want to clear all events for <strong>{leagueName}</strong>?</p>
        <p className="text-danger mb-0">This action cannot be undone.</p>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="danger" 
          onClick={onConfirm}
          disabled={isClearing}
        >
          {isClearing ? 'Clearing...' : 'Yes, Clear Events'}
        </Button>
        <Button 
          color="secondary" 
          onClick={onCancel}
          disabled={isClearing}
        >
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ClearEventsModal;
